import { appStore } from '../../app/AppStore';
import { siteUrlsSelector } from '../../app/selectors/SiteUrlsSelectors';
import { Location } from '../../common/react/Location';
import { IGetGroupDetailInfoResult } from '../models/IGroupInfo';
import { Module } from '../Module';
import { Groups } from '../resources/Groups';
import { SiteRolesResource } from '../resources/SiteRoles';
import { SiteRoles } from '../ServerApi/types/ISiteRole';
import { BrowserTitleService } from '../services/BrowserTitleService';
import { GroupActions } from '../services/GroupActions';
import { ServerService } from '../services/ServerService';
import { UpdateGroupsMinimumSiteRoleAction } from '../services/UpdateGroupsMinimumSiteRoleAction';

export interface IGroupDetailsModel {
  domainName: string;
  createdAt: string;
  updatedAt: string;
  isAllUsersGroup: boolean;
  minimumSiteRole?: string;
}

// Group Details

export interface IGroupDetailsCtrl extends ng.IScope {
  groupDetails: IGetGroupDetailInfoResult;
  canSessionUserManageUsers: boolean;
  deleteGroup: ($event: JQueryEventObject) => void;
  groupDetailsModel: IGroupDetailsModel;
  isLocalGroup: () => boolean;
  isAllUsersGroup: () => boolean;
  objectName: string;

  // Variables for modifying site role
  allowMinimumSiteRole: boolean;
  isEditingMinimumSiteRole: boolean;
  isSavingMinimumSiteRole: boolean;
  siteRoleOptions: string[];
  editSiteRole: () => void;
  saveSiteRole: () => void;
  cancelSiteRole: () => void;
}

export class GroupDetailsCtrl {

  public static $inject = [
    '$scope',
    'BrowserTitleService',
    'GroupActions',
    'ServerService',
    'SiteRoles',
    'UpdateGroupsMinimumSiteRoleAction'
  ];

  constructor(
            $scope: IGroupDetailsCtrl,
            BrowserTitleService: BrowserTitleService,
            groupActions: GroupActions,
            serverService: ServerService,
            siteRoles: SiteRolesResource,
            updateGroupsMinimumSiteRoleAction: UpdateGroupsMinimumSiteRoleAction
  ) {
    BrowserTitleService.setTitleWithPlaceEntityNameAndSubplaceName({placeEntityName: $scope.objectName, translatableSubplaceName: 'details'});
    const groupDetails = $scope.groupDetails; // this group comes from the GroupSubspaceProvider

    $scope.groupDetailsModel = {
      domainName: groupDetails.domainName,
      createdAt: groupDetails.createdAt,
      updatedAt: groupDetails.updatedAt,
      isAllUsersGroup: groupDetails.isAllUsersGroup,
      minimumSiteRole: groupDetails.minimumSiteRole
    };

    $scope.isLocalGroup = () => {
      const domainName = $scope.groupDetailsModel.domainName;
      return !(domainName && domainName !== 'local');
    };

    $scope.isAllUsersGroup = () => {
      return $scope.groupDetailsModel.isAllUsersGroup || false;
    };

    $scope.deleteGroup = ($event: JQueryEventObject) => {
      groupActions.deleteGroup(groupDetails, $scope).then(() => {
        const siteUrls = siteUrlsSelector(appStore.getState());
        Location.instance.setUrl(siteUrls.groupsUrl());
      });
    };

    $scope.allowMinimumSiteRole = serverService.isServerDomainFamilyActiveDirectory()
                               && Groups.isActiveDirectory(groupDetails);

    if($scope.allowMinimumSiteRole) {
      $scope.isEditingMinimumSiteRole = false;
      $scope.siteRoleOptions = siteRoles.optionsForCurrentUserExcept(SiteRoles.ServerAdministrator);

      $scope.editSiteRole = () => {
        $scope.isEditingMinimumSiteRole = true;
        $scope.isSavingMinimumSiteRole = false;
      };

      const resetEditSiteRole = () => {
        $scope.isEditingMinimumSiteRole = false;
        $scope.groupDetailsModel.minimumSiteRole = groupDetails.minimumSiteRole;
      };

      $scope.saveSiteRole = () => {
        $scope.isSavingMinimumSiteRole = true;
        const savingMinimumSiteRole = $scope.groupDetailsModel.minimumSiteRole;
        updateGroupsMinimumSiteRoleAction.executeInPlace(groupDetails, savingMinimumSiteRole)
          .then(() => {
            groupDetails.minimumSiteRole = savingMinimumSiteRole;
            resetEditSiteRole();
          })
          .finally(() => {
            $scope.isSavingMinimumSiteRole = false;
          });
      };

      $scope.cancelSiteRole = resetEditSiteRole;
    }
  }
}

Module.instance().controller('GroupDetailsCtrl', GroupDetailsCtrl);
